import { render } from "./VerifyRecaptcha.vue?vue&type=template&id=e93efd2c"
import script from "./VerifyRecaptcha.vue?vue&type=script&lang=js"
export * from "./VerifyRecaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__